import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage-entrymetadata" id="module-storage-entrymetadata"></a>
    <h1 {...{
      "id": "requireuxpstorageentrymetadata"
    }}>{`require('uxp').storage.EntryMetadata`}</h1>
    <p>{`Metadata for an entry. It includes useful information such as:`}</p>
    <ul>
      <li parentName="ul">{`size of the file (if a file)`}</li>
      <li parentName="ul">{`date created`}</li>
      <li parentName="ul">{`date modified`}</li>
      <li parentName="ul">{`name`}</li>
    </ul>
    <p>{`You'll not instantiate this directly; use `}<a parentName="p" {...{
        "href": "/uxp-photoshop-zh-cn/uxp/reference-js/Modules/uxp/Persistent%20File%20Storage/Entry/#module-storage-entry-getmetadata"
      }}>{`Entry#getMetadata`}</a>{` to do so.`}</p>
    <a name="module-storage-entrymetadata-name" id="module-storage-entrymetadata-name"></a>
    <h2 {...{
      "id": "name--string"
    }}>{`name : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`The name of the entry.`}</p>
    <a name="module-storage-entrymetadata-size" id="module-storage-entrymetadata-size"></a>
    <h2 {...{
      "id": "size--number"
    }}>{`size : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The size of the entry, if a file. Zero if a folder.`}</p>
    <a name="module-storage-entrymetadata-datecreated" id="module-storage-entrymetadata-datecreated"></a>
    <h2 {...{
      "id": "datecreated--date"
    }}>{`dateCreated : `}<inlineCode parentName="h2">{`Date`}</inlineCode></h2>
    <p>{`The date this entry was created.`}</p>
    <a name="module-storage-entrymetadata-datemodified" id="module-storage-entrymetadata-datemodified"></a>
    <h2 {...{
      "id": "datemodified--date"
    }}>{`dateModified : `}<inlineCode parentName="h2">{`Date`}</inlineCode></h2>
    <p>{`The date this entry was modified.`}</p>
    <a name="module-storage-entrymetadata-isfile" id="module-storage-entrymetadata-isfile"></a>
    <h2 {...{
      "id": "isfile--boolean"
    }}>{`isFile : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Indicates if the entry is a file`}</p>
    <a name="module-storage-entrymetadata-isfolder" id="module-storage-entrymetadata-isfolder"></a>
    <h2 {...{
      "id": "isfolder--boolean"
    }}>{`isFolder : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Indicates if the entry is a folder`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      